export const GenericInfoEnums = {
    All:"All",
    Tier1: "Tier-1",
    Tier2: "Tier-2",
    OtherTiers: "Other-Tiers",
    MyConnectivity: "myConnectivity"
}